import { ChevronsUpDown } from "lucide-react";
import { useNavigate } from "react-router";
import type { Workspace } from "@/api/types";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

/** Troca de workspace (a escolha fica na URL). `bare` = sem borda, para o topo do celular. */
export function WorkspaceSwitcher({
  current,
  workspaces,
  bare = false,
}: {
  current: Workspace;
  workspaces: Workspace[];
  bare?: boolean;
}) {
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`Workspace: ${current.name}`}
        className={cn(
          "flex min-h-12 min-w-0 items-center justify-between gap-2 rounded-chip px-3 text-left text-ink",
          "focus-visible:outline-2 focus-visible:outline-accent",
          bare ? "px-1 hover:bg-surface-2" : "w-full border border-border bg-surface hover:bg-surface-2",
        )}
      >
        <span className="flex min-w-0 flex-col leading-tight">
          <span className="text-xs text-muted">Workspace</span>
          <span className="truncate text-[15px] font-semibold">{current.name}</span>
        </span>
        <ChevronsUpDown aria-hidden="true" className="size-4 shrink-0 text-muted" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuLabel>Seus workspaces</DropdownMenuLabel>
        <DropdownMenuRadioGroup value={current.id} onValueChange={(id) => navigate(`/w/${id}`)}>
          {workspaces.map((w) => (
            <DropdownMenuRadioItem key={w.id} value={w.id}>
              {w.name}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
